module.exports = __webpack_public_path__ + "static/kubesova-fe60bff93bb629af28683bde753c1946.jpg";